
import { QSelect } from 'quasar';
import { defineComponent, ref, PropType, computed } from 'vue';

type FilterUpdateFn = { (fn: () => void): void };

export default defineComponent({
  name: 'TypeSelect',
  props: {
    options: {
      type: Array as PropType<string[]> | undefined,
      required: true,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Selecione uma opção...',
    },
    modelValue: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const collection = ref<string[]>(props.options);
    const selection = computed({
      get: () => props.modelValue,
      set: (val) => emit('update:modelValue', val),
    });
    const qSelectedRef = ref<QSelect>();
    const filterFn = (val: string, update: FilterUpdateFn) => {
      update(() => {
        if (val === '') {
          collection.value = props.options;
        } else {
          const needle = val.toLowerCase();
          collection.value = props.options?.filter(
            (v) => v.toLowerCase().indexOf(needle) > -1
          );
        }
      });
    };

    const updateInput = () => {
      qSelectedRef.value?.updateInputValue('');
    };
    return {
      qSelectedRef,
      collection,
      selection,
      updateInput,
      filterFn,
    };
  },
});
